import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import { Separator } from "../components/ui/separator";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { ScrollArea } from "../components/ui/scroll-area";
import { toast } from "sonner";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { formatDateBR } from "../utils/dateUtils";
import {
  Music,
  Heart,
  Brain,
  GraduationCap,
  Dumbbell,
  Calendar,
  MapPin,
  Clock,
  User,
  Target,
  Loader2,
  ArrowLeft,
  CheckCircle,
  Users,
  HandHeart,
  Shirt,
  Package,
  Apple,
  Cross,
  DollarSign,
  CreditCard,
  MessageCircle,
  AlertCircle,
  Copy,
  Users2,
  Upload,
  Image,
  Search,
  UserPlus,
  Baby,
  Plus,
  X
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PROJECT_TYPES = [
  { value: "musica", label: "Música", icon: Music, color: "bg-purple-500" },
  { value: "doacoes", label: "Doações", icon: Heart, color: "bg-red-500" },
  { value: "terapias", label: "Terapias", icon: Brain, color: "bg-blue-500" },
  { value: "cursos", label: "Cursos", icon: GraduationCap, color: "bg-green-500" },
  { value: "esporte", label: "Esporte", icon: Dumbbell, color: "bg-orange-500" },
  { value: "oracao", label: "Oração", icon: HandHeart, color: "bg-indigo-500" },
  { value: "evento_dupla", label: "Evento em Dupla", icon: Users2, color: "bg-pink-500" },
];

const PROJECT_ICONS = {
  "default": null,
  "music": Music,
  "heart": Heart,
  "hand-heart": HandHeart,
  "shirt": Shirt,
  "package": Package,
  "apple": Apple,
  "brain": Brain,
  "graduation": GraduationCap,
  "dumbbell": Dumbbell,
  "cross": Cross,
};

const ORACAO_AREAS = [
  { value: "financeira", label: "Área Financeira" },
  { value: "familiar", label: "Área Familiar" },
  { value: "conjugal", label: "Área Conjugal" },
  { value: "relacionamentos", label: "Relacionamentos" },
  { value: "vida_espiritual", label: "Vida Espiritual" },
  { value: "emocional", label: "Área Emocional" },
  { value: "saude", label: "Saúde" },
  { value: "profissional", label: "Área Profissional" },
  { value: "outros", label: "Outros" },
];

const FORMAS_PAGAMENTO = [
  { value: "pix", label: "PIX" },
  { value: "dinheiro", label: "Dinheiro" },
  { value: "cartao_credito", label: "Cartão de Crédito" },
  { value: "cartao_debito", label: "Cartão de Débito" },
  { value: "transferencia", label: "Transferência Bancária" },
];

export default function ProjectEnrollPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const fileInputRef = useRef(null);
  
  const [loading, setLoading] = useState(true);
  const [enrolling, setEnrolling] = useState(false);
  const [project, setProject] = useState(null);
  const [pessoaAtual, setPessoaAtual] = useState(null);
  const [jaInscrito, setJaInscrito] = useState(false);
  const [inscricaoPendente, setInscricaoPendente] = useState(false);
  const [liderContato, setLiderContato] = useState(null);
  const [podeSelecionarPessoa, setPodeSelecionarPessoa] = useState(false);
  const [people, setPeople] = useState([]);
  const [selectedPessoaId, setSelectedPessoaId] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [criancas, setCriancas] = useState([{ nome: "", idade: "" }]);
  const isInfantil = project?.tipo === "evento_infantil";
  const criancasValidas = criancas.filter(c => c.nome.trim());

  const CriancasFields = () => (
    <div className="p-4 rounded-xl border border-yellow-200 bg-yellow-50/50 space-y-3" data-testid="enroll-children-box">
      <p className="text-sm font-semibold text-yellow-800 flex items-center gap-2"><Baby className="h-4 w-4" /> Crianças que vão participar</p>
      {criancas.map((c, i) => (
        <div key={i} className="flex gap-2 items-end">
          <div className="flex-1 min-w-0">
            <Label className="text-xs">Nome da criança *</Label>
            <Input value={c.nome} onChange={(e) => setCriancas(prev => prev.map((x, j) => j === i ? { ...x, nome: e.target.value } : x))} placeholder="Nome completo" className="bg-white" data-testid={`enroll-child-name-${i}`} />
          </div>
          <div className="w-[84px] shrink-0">
                <Label className="text-xs">Idade</Label>
                <Input type="number" inputMode="numeric" min={0} max={17} placeholder="anos" value={c.idade} onChange={(e) => setCriancas(prev => prev.map((x, j) => j === i ? { ...x, idade: e.target.value } : x))} className="bg-white min-w-0" />
              </div>
          {criancas.length > 1 && (
            <Button type="button" variant="ghost" size="icon" className="h-9 w-9 text-red-500 shrink-0" onClick={() => setCriancas(prev => prev.filter((_, j) => j !== i))}><X className="h-4 w-4" /></Button>
          )}
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" className="w-full" onClick={() => setCriancas(prev => [...prev, { nome: "", idade: "" }])} data-testid="enroll-child-add">
        <Plus className="h-4 w-4 mr-1" /> Adicionar outra criança
      </Button>
    </div>
  );
  
  // Campos específicos de oração
  const [areaOracao, setAreaOracao] = useState("");
  const [pedidoOracao, setPedidoOracao] = useState("");
  
  // Campos específicos de pagamento (eventos pagos)
  const [formaPagamento, setFormaPagamento] = useState("");
  const [dataPagamento, setDataPagamento] = useState("");
  
  // Campos específicos de evento em dupla
  const [convidadoTipo, setConvidadoTipo] = useState("avulso"); // "avulso" ou "cadastrado"
  const [convidadoNome, setConvidadoNome] = useState("");
  const [convidadoTelefone, setConvidadoTelefone] = useState("");
  const [convidadoEmail, setConvidadoEmail] = useState("");
  const [convidadoPessoaId, setConvidadoPessoaId] = useState("");
  const [buscaConvidado, setBuscaConvidado] = useState("");
  const [dialogBuscaConvidado, setDialogBuscaConvidado] = useState(false);
  
  // Campos para formulário público (não logado)
  const [telefonePublico, setTelefonePublico] = useState("");
  const [buscandoPessoa, setBuscandoPessoa] = useState(false);
  const [pessoaEncontrada, setPessoaEncontrada] = useState(null);
  const [etapaFormulario, setEtapaFormulario] = useState("telefone"); // "telefone", "dados", "confirmacao"
  const [dadosPublicos, setDadosPublicos] = useState({
    nome_completo: "",
    email: "",
    data_nascimento: "",
    endereco: "",
    bairro: "",
    cidade: "",
    sexo: "",
    estado_civil: "",
    situacao: "",
    batismo: "",
    ministerios_desejados: ""
  });
  
  // Upload de comprovante
  const [uploadingComprovante, setUploadingComprovante] = useState(false);
  const [inscricaoData, setInscricaoData] = useState(null); // Dados da inscrição após realizada

  useEffect(() => {
    loadData();
  }, [projectId]);

  const loadData = async () => {
    try {
      // Try authenticated endpoint first, fallback to public if no token
      let enrollmentRes;
      
      if (token) {
        // User is logged in - use authenticated endpoint
        try {
          enrollmentRes = await axios.get(`${API}/projects/${projectId}/enrollment-info`);
          const data = enrollmentRes.data;
          setProject(data.project);
          setPessoaAtual(data.pessoa_atual);
          setJaInscrito(data.ja_inscrito);
          setInscricaoPendente(data.inscricao_pendente || false);
          setLiderContato(data.lider_contato);
          setPodeSelecionarPessoa(data.pode_selecionar_pessoa);
          
          if (data.pessoa_atual) {
            setSelectedPessoaId(data.pessoa_atual.id);
          }
          
          // Only load people if user can select person (has permission)
          if (data.pode_selecionar_pessoa) {
            try {
              const peopleRes = await axios.get(`${API}/people`);
              setPeople(peopleRes.data);
            } catch {
              // Ignore if can't load people
            }
          }
        } catch (authError) {
          // If auth fails, try public endpoint
          enrollmentRes = await axios.get(`${API}/public/projects/${projectId}/enrollment-info`);
          setProject(enrollmentRes.data.project);
          setLiderContato(enrollmentRes.data.lider_contato);
        }
      } else {
        // No user logged in - use public endpoint
        enrollmentRes = await axios.get(`${API}/public/projects/${projectId}/enrollment-info`);
        setProject(enrollmentRes.data.project);
        setLiderContato(enrollmentRes.data.lider_contato);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      toast.error("Projeto não disponível para inscrição");
      navigate("/news");
    } finally {
      setLoading(false);
    }
  };

  const getTypeInfo = (tipo) => {
    return PROJECT_TYPES.find(t => t.value === tipo) || PROJECT_TYPES[0];
  };

  const formatDate = (dateStr) => {
    return formatDateBR(dateStr);
  };

  // Buscar pessoa por telefone (formulário público)
  const buscarPessoaPorTelefone = async () => {
    if (!telefonePublico || telefonePublico.length < 8) {
      toast.error("Informe um telefone válido");
      return;
    }
    
    setBuscandoPessoa(true);
    try {
      const res = await axios.get(`${API}/public/lookup-by-phone/${encodeURIComponent(telefonePublico)}`);
      
      if (res.data.found) {
        // Pessoa encontrada - preencher dados automaticamente
        setPessoaEncontrada(res.data.pessoa);
        setDadosPublicos({
          nome_completo: res.data.pessoa.nome_completo || "",
          email: res.data.pessoa.email || "",
          data_nascimento: res.data.pessoa.data_nascimento || "",
          endereco: res.data.pessoa.endereco || "",
          bairro: res.data.pessoa.bairro || "",
          cidade: res.data.pessoa.cidade || "",
          sexo: res.data.pessoa.sexo || "",
          estado_civil: res.data.pessoa.estado_civil || "",
          situacao: res.data.pessoa.situacao || "",
          batismo: res.data.pessoa.batismo || "",
          ministerios_desejados: res.data.pessoa.ministerios_desejados?.join(", ") || ""
        });
        toast.success(`Cadastro encontrado: ${res.data.pessoa.nome_completo}`);
      } else {
        // Pessoa não encontrada - ir para formulário
        setPessoaEncontrada(null);
        setDadosPublicos({
          nome_completo: "",
          email: "",
          data_nascimento: "",
          endereco: "",
          bairro: "",
          cidade: "",
          sexo: "",
          estado_civil: "",
          situacao: "",
          batismo: "",
          ministerios_desejados: ""
        });
        toast.info("Cadastro não encontrado. Preencha seus dados para continuar.");
      }
      setEtapaFormulario("dados");
    } catch (error) {
      toast.error("Erro ao buscar cadastro");
    } finally {
      setBuscandoPessoa(false);
    }
  };

  // Inscrição pública (sem login)
  const handleEnrollPublico = async () => {
    // Validação básica
    if (!dadosPublicos.nome_completo.trim()) {
      toast.error("Nome é obrigatório");
      return;
    }
    
    // Validação para evento em dupla (convidado obrigatório)
    if (project.tipo === "evento_dupla" && !convidadoNome.trim()) {
      toast.error("Informe o nome do seu convidado");
      return;
    }
    
    // Verifica se deve enviar cada campo do convidado
    const hasAnyConvidadoField = project.tipo === "evento_dupla" || 
      project.campos_inscricao_externa?.includes("convidado") ||
      project.campos_inscricao_externa?.includes("convidado_nome") ||
      project.campos_inscricao_externa?.includes("convidado_telefone") ||
      project.campos_inscricao_externa?.includes("convidado_email");
    
    setEnrolling(true);
    try {
      const enrollData = {
        nome_completo: dadosPublicos.nome_completo,
        telefone: telefonePublico,
        email: dadosPublicos.email || undefined,
        data_nascimento: dadosPublicos.data_nascimento || undefined,
        endereco: dadosPublicos.endereco || undefined,
        bairro: dadosPublicos.bairro || undefined,
        cidade: dadosPublicos.cidade || undefined,
        sexo: dadosPublicos.sexo || undefined,
        estado_civil: dadosPublicos.estado_civil || undefined,
        situacao: dadosPublicos.situacao || undefined,
        batismo: dadosPublicos.batismo || undefined,
        ministerios_desejados: dadosPublicos.ministerios_desejados || undefined,
        observacoes,
        // Campos específicos de oração
        area_oracao: project.tipo === "oracao" ? areaOracao : undefined,
        pedido_oracao: project.tipo === "oracao" ? pedidoOracao : undefined,
        // Campos específicos de pagamento
        forma_pagamento: (!project.gratuito && project.valor_inscricao > 0) ? formaPagamento : undefined,
        data_pagamento: (!project.gratuito && project.valor_inscricao > 0 && dataPagamento) ? dataPagamento : undefined,
        // Campos do convidado (quando algum campo estiver ativo)
        convidado_nome: hasAnyConvidadoField && convidadoNome ? convidadoNome : undefined,
        convidado_telefone: hasAnyConvidadoField && convidadoTelefone ? convidadoTelefone : undefined,
        convidado_email: hasAnyConvidadoField && convidadoEmail ? convidadoEmail : undefined,
      };
      
      if (isInfantil) {
        enrollData.criancas = criancasValidas;
        if (criancasValidas.length === 0) { toast.error("Informe o nome de pelo menos uma criança"); setEnrolling(false); return; }
      }
      const response = await axios.post(`${API}/public/projects/${projectId}/enroll`, enrollData);
      
      toast.success("Inscrição realizada com sucesso!");
      setEtapaFormulario("confirmacao");
      setInscricaoData(response.data);
    } catch (error) {
      console.error("Enrollment error:", error.response?.data);
      const errorMessage = error.response?.data?.detail || "Erro ao realizar inscrição. Tente novamente.";
      toast.error(errorMessage);
    } finally {
      setEnrolling(false);
    }
  };

  const handleEnroll = async () => {
    // Validação de participante
    if (!selectedPessoaId && !pessoaAtual) {
      if (podeSelecionarPessoa) {
        toast.error("Selecione uma pessoa para fazer a inscrição");
      } else {
        toast.error("Você precisa ter um cadastro para se inscrever");
      }
      return;
    }
    
    // Validação específica para oração
    if (project.tipo === "oracao") {
      if (!areaOracao) {
        toast.error("Selecione uma área para o pedido de oração");
        return;
      }
      if (!pedidoOracao.trim()) {
        toast.error("Descreva seu pedido de oração");
        return;
      }
    }
    
    // Validação específica para evento em dupla
    if (project.tipo === "evento_dupla") {
      if (convidadoTipo === "avulso" && !convidadoNome.trim()) {
        toast.error("Informe o nome do seu convidado");
        return;
      }
      if (convidadoTipo === "cadastrado" && !convidadoPessoaId) {
        toast.error("Selecione uma pessoa cadastrada como convidado");
        return;
      }
    }
    
    // Validação específica para eventos pagos
    const isPago = !project.gratuito && project.valor_inscricao > 0;
    if (isPago && !formaPagamento) {
      toast.error("Selecione a forma de pagamento");
      return;
    }

    setEnrolling(true);
    try {
      // Para evento_dupla, usar endpoint específico
      if (project.tipo === "evento_dupla") {
        // Buscar nome do convidado se for pessoa cadastrada
        let nomeConvidado = convidadoNome;
        if (convidadoTipo === "cadastrado" && convidadoPessoaId) {
          const pessoaSelecionada = people.find(p => p.id === convidadoPessoaId);
          nomeConvidado = pessoaSelecionada?.nome_completo || "";
        }
        
        const duplaData = {
          pessoa_id: selectedPessoaId || undefined, // Se líder/admin está inscrevendo outra pessoa
          observacoes,
          forma_pagamento: isPago ? formaPagamento : undefined,
          data_pagamento: isPago && dataPagamento ? dataPagamento : undefined,
          convidado_pessoa_id: convidadoTipo === "cadastrado" ? convidadoPessoaId : undefined,
          convidado_nome: nomeConvidado || undefined,
          convidado_telefone: convidadoTelefone || undefined,
          convidado_email: convidadoEmail || undefined,
        };
        
        const response = await axios.post(`${API}/projects/${projectId}/inscricao-dupla`, duplaData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        toast.success(`Inscrição em dupla realizada! Número: ${response.data.numero_inscricao}`);
        setInscricaoData(response.data);
        setJaInscrito(true);
        return;
      }
      
      const enrollData = {
        pessoa_id: podeSelecionarPessoa ? selectedPessoaId : undefined,
        observacoes,
        // Campos específicos de oração
        area_oracao: project.tipo === "oracao" ? areaOracao : undefined,
        pedido_oracao: project.tipo === "oracao" ? pedidoOracao : undefined,
        // Campos específicos de pagamento
        forma_pagamento: isPago ? formaPagamento : undefined,
        data_pagamento: isPago && dataPagamento ? dataPagamento : undefined,
        criancas: isInfantil ? criancasValidas : undefined,
      };
      if (isInfantil && criancasValidas.length === 0) {
        toast.error("Informe o nome de pelo menos uma criança");
        setEnrolling(false);
        return;
      }
      
      const response = await axios.post(`${API}/projects/${projectId}/enroll`, enrollData);
      
      const successMessage = project.tipo === "oracao" 
        ? "Pedido de oração enviado com sucesso!" 
        : "Inscrição realizada com sucesso!";
      
      toast.success(successMessage);
      
      // Se for evento pago, manter na página para permitir upload de comprovante
      if (isPago) {
        setInscricaoData(response.data);
        setJaInscrito(true);
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao realizar inscrição");
    } finally {
      setEnrolling(false);
    }
  };
  
  // Função para upload de comprovante de pagamento
  const handleUploadComprovante = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    
    // Validar tamanho (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Arquivo muito grande (máximo 5MB)");
      return;
    }
    
    // Validar tipo
    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Tipo de arquivo não permitido. Use: JPG, PNG, GIF ou PDF");
      return;
    }
    
    setUploadingComprovante(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      const pessoaId = pessoaAtual?.id || selectedPessoaId;
      
      await axios.post(
        `${API}/projects/${projectId}/participants/${pessoaId}/comprovante`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );
      
      toast.success("Comprovante enviado! Pagamento confirmado automaticamente.");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao enviar comprovante");
    } finally {
      setUploadingComprovante(false);
    }
  };
  
  // Função para buscar pessoas (para selecionar convidado)
  const filteredPeople = people.filter(p => 
    p.nome_completo?.toLowerCase().includes(buscaConvidado.toLowerCase()) ||
    p.telefone?.includes(buscaConvidado)
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!project) {
    return (
      <div className="text-center py-12">
        <p>Projeto não encontrado</p>
        <Button variant="link" onClick={() => navigate("/social")}>
          Voltar para Projetos
        </Button>
      </div>
    );
  }

  const typeInfo = getTypeInfo(project.tipo);
  const TypeIcon = typeInfo.icon;

  return (
    <div className="space-y-4 max-w-2xl mx-auto">
      {/* Header Compacto */}
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="h-8 w-8">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-lg font-bold leading-tight">Inscrição</h1>
          <p className="text-xs text-muted-foreground">Preencha os dados para participar</p>
        </div>
      </div>

      {/* Project Info Card - Layout Compacto */}
      <Card className="border-0 shadow-sm">
        <CardContent className="p-4 space-y-3">
          {/* Cabeçalho do Projeto */}
          <div className="flex items-start gap-3">
            <div className={`p-2 rounded-lg ${typeInfo.color} text-white shrink-0`}>
              <TypeIcon className="h-5 w-5" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="font-semibold text-base leading-tight truncate">{project.nome}</h2>
              <p className="text-xs text-muted-foreground">{typeInfo.label}</p>
            </div>
            {/* Valor em destaque se for pago */}
            {!project.gratuito && project.valor_inscricao > 0 && (
              <div className="text-right shrink-0">
                <p className="text-xs text-muted-foreground">Valor</p>
                <p className="font-bold text-green-600">R$ {project.valor_inscricao.toFixed(2).replace('.', ',')}</p>
              </div>
            )}
          </div>

          {/* Info Grid Compacto */}
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
            {project.lider_nome && (
              <span className="flex items-center gap-1">
                <User className="h-3 w-3" />
                {project.lider_nome}
              </span>
            )}
            {project.data_evento && (
              <span className="flex items-center gap-1">
                <Calendar className="h-3 w-3" />
                {formatDate(project.data_evento)}
              </span>
            )}
            {project.horario_evento && (
              <span className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {project.horario_evento}
              </span>
            )}
            {project.local && (
              <span className="flex items-center gap-1">
                <MapPin className="h-3 w-3" />
                {project.local}
              </span>
            )}
            {project.dias_horarios && (
              <span className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {project.dias_horarios}
              </span>
            )}
          </div>

          {/* Type-specific info compacto */}
          {project.tipo === "musica" && project.faixa_etaria && (
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              <Users className="h-3 w-3" />
              Faixa etária: {project.faixa_etaria}
            </span>
          )}
          
          {project.tipo === "cursos" && (project.area_curso || project.carga_horaria) && (
            <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
              {project.area_curso && (
                <span className="flex items-center gap-1">
                  <Target className="h-3 w-3" />
                  {project.area_curso}
                </span>
              )}
              {project.carga_horaria && (
                <span className="flex items-center gap-1">
                  <Clock className="h-3 w-3" />
                  {project.carga_horaria}
                </span>
              )}
            </div>
          )}
          
          {project.tipo === "esporte" && project.modalidade && (
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              <Dumbbell className="h-3 w-3" />
              {project.modalidade}
            </span>
          )}

          {/* Observações no final, se houver */}
          {project.objetivo && (
            <p className="text-xs text-muted-foreground pt-1 border-t">
              {project.objetivo}
            </p>
          )}
        </CardContent>
      </Card>

      {/* Donation Pending Card - For donation projects when user has pending enrollment */}
      {inscricaoPendente && project.tipo === "doacoes" ? (
        <Card className="border-amber-200 bg-amber-50 dark:bg-amber-950/20">
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <AlertCircle className="h-8 w-8 text-amber-600" />
              <div>
                <p className="font-semibold text-amber-900 dark:text-amber-100">
                  Você já está inscrito neste projeto
                </p>
                <p className="text-sm text-amber-700 dark:text-amber-300">
                  Aguarde ser atendido para realizar uma nova inscrição
                </p>
              </div>
            </div>
            
            {liderContato?.telefone && (
              <div className="mt-4 space-y-2">
                <p className="text-sm text-amber-800 dark:text-amber-200">
                  Precisa falar com o líder?
                </p>
                <Button 
                  className="w-full gap-2 bg-green-600 hover:bg-green-700" 
                  onClick={() => {
                    const whatsappNumber = liderContato.whatsapp;
                    const message = encodeURIComponent(`Olá ${liderContato.nome}, gostaria de saber sobre minha inscrição no projeto ${project.nome}.`);
                    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
                  }}
                >
                  <MessageCircle className="h-4 w-4" />
                  Falar com {liderContato.nome || "o líder"}
                </Button>
              </div>
            )}
            
            <Button variant="outline" className="mt-4 w-full" onClick={() => navigate("/social")}>
              Ver Meus Projetos
            </Button>
          </CardContent>
        </Card>
      ) : jaInscrito && project.tipo !== "doacoes" ? (
        <Card className="border-green-200 bg-green-50 dark:bg-green-950/20">
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <CheckCircle className="h-8 w-8 text-green-600" />
              <div>
                <p className="font-semibold text-green-900 dark:text-green-100">
                  Você já está inscrito neste projeto!
                </p>
                <p className="text-sm text-green-700 dark:text-green-300">
                  Acesse a página de projetos para ver seus detalhes
                </p>
              </div>
            </div>
            <Button className="mt-4 w-full" onClick={() => navigate("/social")}>
              Ver Meus Projetos
            </Button>
          </CardContent>
        </Card>
      ) : !user ? (
        /* ======= FORMULÁRIO PÚBLICO (sem login) ======= */
        <Card className="border-0 shadow-sm">
          <CardContent className="p-4 space-y-4">
            <div className="flex items-center gap-2">
              <UserPlus className="h-4 w-4 text-primary" />
              <h3 className="font-semibold text-sm">
                {etapaFormulario === "telefone" 
                  ? "Verificar Cadastro"
                  : etapaFormulario === "dados"
                    ? pessoaEncontrada ? "Confirmar Dados" : "Preencher Dados"
                    : "Inscrição Confirmada"
                }
              </h3>
            </div>
            
            {/* Etapa 1: Telefone */}
            {etapaFormulario === "telefone" && (
              <div className="space-y-3">
                <div>
                  <Label className="text-xs">Telefone com DDD *</Label>
                  <div className="flex gap-2 mt-1">
                    <Input
                      placeholder="(00) 00000-0000"
                      value={telefonePublico}
                      onChange={(e) => setTelefonePublico(e.target.value)}
                      className="flex-1 h-9 text-sm"
                      data-testid="public-phone-input"
                      autoComplete="off"
                    />
                    <Button 
                      onClick={buscarPessoaPorTelefone}
                      disabled={buscandoPessoa || !telefonePublico}
                      size="sm"
                      className="h-9"
                    >
                      {buscandoPessoa ? (
                        <Loader2 className="h-4 w-4 animate-spin" />
                      ) : (
                        <Search className="h-4 w-4" />
                      )}
                    </Button>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">
                    Cadastro existente será preenchido automaticamente
                  </p>
                </div>
              </div>
            )}

            {/* Etapa 2: Dados */}
            {etapaFormulario === "dados" && (
              <div className="space-y-3">
                {/* Indicador de pessoa encontrada */}
                {pessoaEncontrada && (
                  <div className="p-2 rounded-lg bg-green-50 dark:bg-green-950/30 border border-green-200 dark:border-green-800">
                    <p className="text-xs text-green-800 dark:text-green-200 flex items-center gap-1">
                      <CheckCircle className="h-3 w-3" />
                      Cadastro encontrado!
                    </p>
                  </div>
                )}
                
                {/* Grid de 2 colunas para campos básicos */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <Label className="text-xs">Nome Completo *</Label>
                    <Input
                      value={dadosPublicos.nome_completo}
                      onChange={(e) => setDadosPublicos({...dadosPublicos, nome_completo: e.target.value})}
                      placeholder="Seu nome completo"
                      disabled={!!pessoaEncontrada}
                      className="h-9 text-sm"
                      data-testid="public-name-input"
                      autoComplete="new-password"
                      name="public_enrollment_name_field"
                    />
                  </div>

                  <div>
                    <Label className="text-xs">Telefone</Label>
                    <Input
                      value={telefonePublico}
                      disabled
                      className="bg-muted/50 h-9 text-sm"
                      autoComplete="off"
                    />
                  </div>

                  {/* Email */}
                  {(!project.campos_inscricao_externa?.length || project.campos_inscricao_externa.includes("email")) && (
                    <div>
                      <Label className="text-xs">Email</Label>
                      <Input
                        type="email"
                        value={dadosPublicos.email}
                        onChange={(e) => setDadosPublicos({...dadosPublicos, email: e.target.value})}
                        placeholder="seu@email.com"
                        className="h-9 text-sm"
                        data-testid="public-email-input"
                        autoComplete="off"
                      />
                    </div>
                  )}

                  {/* Data Nascimento */}
                  {project.campos_inscricao_externa?.includes("data_nascimento") && (
                    <div>
                      <Label className="text-xs">Data de Nascimento</Label>
                      <Input
                        type="date"
                        value={dadosPublicos.data_nascimento}
                        onChange={(e) => setDadosPublicos({...dadosPublicos, data_nascimento: e.target.value})}
                        className="h-9 text-sm"
                      />
                    </div>
                  )}

                  {/* Sexo */}
                  {project.campos_inscricao_externa?.includes("sexo") && (
                    <div>
                      <Label className="text-xs">Sexo</Label>
                      <Select 
                        value={dadosPublicos.sexo} 
                        onValueChange={(v) => setDadosPublicos({...dadosPublicos, sexo: v})}
                      >
                        <SelectTrigger className="h-9 text-sm">
                          <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="masculino">Masculino</SelectItem>
                          <SelectItem value="feminino">Feminino</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  )}
                </div>

                {/* Campos de endereço em linha */}
                {(project.campos_inscricao_externa?.includes("endereco") || 
                  project.campos_inscricao_externa?.includes("bairro") || 
                  project.campos_inscricao_externa?.includes("cidade")) && (
                  <div className="grid grid-cols-2 gap-3">
                    {project.campos_inscricao_externa?.includes("endereco") && (
                      <div className="col-span-2">
                        <Label className="text-xs">Endereço</Label>
                        <Input
                          value={dadosPublicos.endereco}
                          onChange={(e) => setDadosPublicos({...dadosPublicos, endereco: e.target.value})}
                          placeholder="Rua, número"
                          className="h-9 text-sm"
                        />
                      </div>
                    )}

                    {project.campos_inscricao_externa?.includes("bairro") && (
                      <div>
                        <Label className="text-xs">Bairro</Label>
                        <Input
                          value={dadosPublicos.bairro}
                          onChange={(e) => setDadosPublicos({...dadosPublicos, bairro: e.target.value})}
                          placeholder="Bairro"
                          className="h-9 text-sm"
                        />
                      </div>
                    )}

                    {project.campos_inscricao_externa?.includes("cidade") && (
                      <div>
                        <Label className="text-xs">Cidade</Label>
                        <Input
                          value={dadosPublicos.cidade}
                          onChange={(e) => setDadosPublicos({...dadosPublicos, cidade: e.target.value})}
                          placeholder="Cidade"
                          className="h-9 text-sm"
                        />
                      </div>
                    )}
                  </div>
                )}

                {/* Campos de seleção em grid */}
                <div className="grid grid-cols-2 gap-3">
                  {project.campos_inscricao_externa?.includes("estado_civil") && (
                    <div>
                      <Label className="text-xs">Estado Civil</Label>
                      <Select 
                        value={dadosPublicos.estado_civil} 
                        onValueChange={(v) => setDadosPublicos({...dadosPublicos, estado_civil: v})}
                      >
                        <SelectTrigger className="h-9 text-sm">
                          <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="solteiro">Solteiro(a)</SelectItem>
                          <SelectItem value="casado">Casado(a)</SelectItem>
                          <SelectItem value="divorciado">Divorciado(a)</SelectItem>
                          <SelectItem value="viuvo">Viúvo(a)</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  )}

                  {project.campos_inscricao_externa?.includes("situacao") && (
                    <div>
                      <Label className="text-xs">Situação</Label>
                      <Select 
                        value={dadosPublicos.situacao} 
                        onValueChange={(v) => setDadosPublicos({...dadosPublicos, situacao: v})}
                      >
                        <SelectTrigger className="h-9 text-sm">
                          <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="membro">Membro</SelectItem>
                          <SelectItem value="congregado">Congregado</SelectItem>
                          <SelectItem value="visitante">Visitante</SelectItem>
                          <SelectItem value="novo_convertido">Novo Convertido</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  )}

                  {project.campos_inscricao_externa?.includes("batismo") && (
                    <div>
                      <Label className="text-xs">Batismo</Label>
                      <Select 
                        value={dadosPublicos.batismo} 
                        onValueChange={(v) => setDadosPublicos({...dadosPublicos, batismo: v})}
                      >
                        <SelectTrigger className="h-9 text-sm">
                          <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="batizado">Batizado</SelectItem>
                          <SelectItem value="nao_batizado">Não Batizado</SelectItem>
                          <SelectItem value="deseja_batizar">Deseja se Batizar</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  )}
                </div>

                {project.campos_inscricao_externa?.includes("ministerios_desejados") && (
                  <div>
                    <Label className="text-xs">Ministérios de interesse</Label>
                    <Textarea
                      value={dadosPublicos.ministerios_desejados}
                      onChange={(e) => setDadosPublicos({...dadosPublicos, ministerios_desejados: e.target.value})}
                      placeholder="Informe os ministérios..."
                      rows={2}
                      className="text-sm resize-none"
                    />
                  </div>
                )}

                {/* Campos de Convidado - Compacto */}
                {(project.tipo === "evento_dupla" || 
                  project.campos_inscricao_externa?.includes("convidado_nome") ||
                  project.campos_inscricao_externa?.includes("convidado_telefone") ||
                  project.campos_inscricao_externa?.includes("convidado_email") ||
                  project.campos_inscricao_externa?.includes("convidado")) && (
                  <div className="p-3 rounded-lg bg-pink-50 dark:bg-pink-950/30 border border-pink-200 dark:border-pink-800">
                    <p className="text-xs font-medium text-pink-900 dark:text-pink-100 flex items-center gap-1 mb-2">
                      <Users2 className="h-3 w-3" />
                      Convidado {project.tipo !== "evento_dupla" && "(opcional)"}
                    </p>
                    
                    <div className="grid grid-cols-2 gap-2">
                      {/* Nome do Convidado */}
                      {(project.tipo === "evento_dupla" || 
                        project.campos_inscricao_externa?.includes("convidado_nome") ||
                        project.campos_inscricao_externa?.includes("convidado")) && (
                        <div className="col-span-2">
                          <Input
                            value={convidadoNome}
                            onChange={(e) => setConvidadoNome(e.target.value)}
                            placeholder={project.tipo === "evento_dupla" ? "Nome do convidado *" : "Nome do convidado"}
                            className="bg-white dark:bg-card h-9 text-sm"
                            data-testid="public-guest-name-input"
                            autoComplete="off"
                          />
                        </div>
                      )}
                      
                      {/* Telefone do Convidado */}
                      {(project.tipo === "evento_dupla" || 
                        project.campos_inscricao_externa?.includes("convidado_telefone") ||
                        project.campos_inscricao_externa?.includes("convidado")) && (
                        <Input
                          value={convidadoTelefone}
                          onChange={(e) => setConvidadoTelefone(e.target.value)}
                          placeholder="Telefone"
                          className="bg-white dark:bg-card h-9 text-sm"
                          autoComplete="off"
                        />
                      )}
                      
                      {/* E-mail do Convidado */}
                      {(project.tipo === "evento_dupla" || 
                        project.campos_inscricao_externa?.includes("convidado_email") ||
                        project.campos_inscricao_externa?.includes("convidado")) && (
                        <Input
                          type="email"
                          value={convidadoEmail}
                          onChange={(e) => setConvidadoEmail(e.target.value)}
                          placeholder="Email"
                          className="bg-white dark:bg-card h-9 text-sm"
                          autoComplete="off"
                        />
                      )}
                    </div>
                  </div>
                )}

                {/* Campos de Oração - Compacto */}
                {project.tipo === "oracao" && (
                  <div className="p-3 rounded-lg bg-indigo-50 dark:bg-indigo-950/30 border border-indigo-200">
                    <p className="text-xs font-medium text-indigo-900 flex items-center gap-1 mb-2">
                      <HandHeart className="h-3 w-3" />
                      Pedido de Oração
                    </p>
                    
                    <div className="space-y-2">
                      {project.areas_oracao?.length > 0 && (
                        <Select value={areaOracao} onValueChange={setAreaOracao}>
                          <SelectTrigger className="bg-white h-9 text-sm">
                            <SelectValue placeholder="Área do pedido" />
                          </SelectTrigger>
                          <SelectContent>
                            {project.areas_oracao.map(area => (
                              <SelectItem key={area} value={area}>{area}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      )}
                      
                      <Textarea
                        value={pedidoOracao}
                        onChange={(e) => setPedidoOracao(e.target.value)}
                        placeholder="Descreva seu pedido de oração..."
                        rows={3}
                        className="bg-white text-sm resize-none"
                      />
                    </div>
                  </div>
                )}

                {/* Campos de Pagamento - Compacto */}
                {!project.gratuito && project.valor_inscricao > 0 && (
                  <div className="p-3 rounded-lg bg-green-50 dark:bg-green-950/30 border border-green-200">
                    <div className="flex items-center justify-between mb-2">
                      <p className="text-xs font-medium text-green-900 flex items-center gap-1">
                        <CreditCard className="h-3 w-3" />
                        Pagamento
                      </p>
                      <span className="text-sm font-bold text-green-700">
                        R$ {project.valor_inscricao.toFixed(2).replace('.', ',')}
                      </span>
                    </div>
                    
                    {project.pix_chave && (
                      <div className="p-2 bg-white rounded border mb-2">
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-muted-foreground">Chave PIX</span>
                          <Button
                            variant="ghost"
                            size="sm"
                            className="h-6 text-xs px-2"
                            onClick={() => {
                              navigator.clipboard.writeText(project.pix_chave);
                              toast.success("Chave PIX copiada!");
                            }}
                          >
                            <Copy className="h-3 w-3 mr-1" />
                            Copiar
                          </Button>
                        </div>
                        <p className="font-mono text-xs break-all mt-1">{project.pix_chave}</p>
                      </div>
                    )}
                    
                    <div className="space-y-2">
                      <div>
                        <Label className="text-xs text-green-900">Forma de Pagamento *</Label>
                        <Select value={formaPagamento} onValueChange={setFormaPagamento}>
                          <SelectTrigger className="bg-white h-9 text-sm">
                            <SelectValue placeholder="Selecione" />
                          </SelectTrigger>
                          <SelectContent>
                            {FORMAS_PAGAMENTO.map(forma => (
                              <SelectItem key={forma.value} value={forma.value}>{forma.label}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      
                      <div>
                        <Label className="text-xs text-green-900">Previsão de Pagamento</Label>
                        <Input
                          type="date"
                          value={dataPagamento}
                          onChange={(e) => setDataPagamento(e.target.value)}
                          className="bg-white h-9 text-sm w-full"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {isInfantil && CriancasFields()}

                <div className="flex gap-2 pt-2">
                  <Button 
                    variant="outline" 
                    onClick={() => {
                      setEtapaFormulario("telefone");
                      setPessoaEncontrada(null);
                    }}
                    size="sm"
                    className="flex-1"
                  >
                    Voltar
                  </Button>
                  <Button 
                    onClick={handleEnrollPublico}
                    disabled={enrolling || !dadosPublicos.nome_completo}
                    size="sm"
                    className="flex-1"
                  >
                    {enrolling ? (
                      <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    ) : (
                      <CheckCircle className="h-4 w-4 mr-2" />
                    )}
                    {enrolling ? "Inscrevendo..." : "Confirmar Inscrição"}
                  </Button>
                </div>
              </div>
            )}

            {/* Etapa 3: Confirmação */}
            {etapaFormulario === "confirmacao" && (
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-green-800 dark:text-green-200">Inscrição Realizada!</h3>
                  <p className="text-muted-foreground">
                    Sua inscrição em <strong>{project.nome}</strong> foi confirmada.
                  </p>
                </div>
                
                {inscricaoData?.numero_inscricao && (
                  <div className="p-3 bg-muted/50 rounded-lg">
                    <p className="text-sm text-muted-foreground">Número da inscrição</p>
                    <p className="text-2xl font-bold">{inscricaoData.numero_inscricao}</p>
                  </div>
                )}
                
                {/* Mostrar info do convidado quando preenchido */}
                {convidadoNome && (
                  <div className="p-4 bg-pink-50 dark:bg-pink-950/30 rounded-lg border border-pink-200 dark:border-pink-800">
                    <p className="text-sm text-pink-700 dark:text-pink-300 flex items-center justify-center gap-2">
                      <Users2 className="h-4 w-4" />
                      Convidado(a): <strong>{convidadoNome}</strong>
                    </p>
                  </div>
                )}
                
                <Button onClick={() => navigate("/news")} className="w-full">
                  Voltar para o Início
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Dados da Inscrição</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {/* Person Selection */}
            {podeSelecionarPessoa ? (
              <div>
                <Label>Participante</Label>
                <Select value={selectedPessoaId} onValueChange={setSelectedPessoaId}>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione a pessoa" />
                  </SelectTrigger>
                  <SelectContent position="popper" className="max-h-[200px]">
                    {people.map(person => (
                      <SelectItem key={person.id} value={person.id}>
                        {person.nome_completo}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            ) : pessoaAtual ? (
              <div className="p-4 bg-muted/50 rounded-lg">
                <Label className="text-muted-foreground text-xs">Participante</Label>
                <p className="font-medium text-lg">{pessoaAtual.nome_completo}</p>
                <p className="text-sm text-muted-foreground">{pessoaAtual.email}</p>
              </div>
            ) : (
              <div className="p-4 bg-yellow-50 dark:bg-yellow-950/30 rounded-lg border border-yellow-200 dark:border-yellow-900">
                <p className="text-sm text-yellow-800 dark:text-yellow-200">
                  Você precisa ter um cadastro de pessoa vinculado ao seu usuário para se inscrever.
                  Entre em contato com o administrador.
                </p>
              </div>
            )}
            
            {/* Observations - only show if user has edit permission and not prayer type */}
            {podeSelecionarPessoa && project.tipo !== "oracao" && (
              <div>
                <Label>Observações (opcional)</Label>
                <Textarea
                  value={observacoes}
                  onChange={(e) => setObservacoes(e.target.value)}
                  placeholder="Alguma informação adicional que queira informar..."
                  rows={3}
                />
              </div>
            )}
            
            {/* Prayer-specific fields */}
            {project.tipo === "oracao" && (
              <div className="space-y-4 p-4 rounded-lg bg-indigo-50 dark:bg-indigo-950/30 border border-indigo-200 dark:border-indigo-900">
                <h4 className="font-semibold text-indigo-900 dark:text-indigo-100 flex items-center gap-2">
                  <HandHeart className="h-5 w-5" />
                  Pedido de Oração
                </h4>
                
                <div>
                  <Label className="text-indigo-900 dark:text-indigo-100">Área do Pedido *</Label>
                  <Select value={areaOracao} onValueChange={setAreaOracao}>
                    <SelectTrigger className="bg-white dark:bg-card">
                      <SelectValue placeholder="Selecione a área" />
                    </SelectTrigger>
                    <SelectContent position="popper" className="max-h-[200px]">
                      {(project.areas_oracao?.length > 0 ? 
                        ORACAO_AREAS.filter(a => project.areas_oracao.includes(a.value)) : 
                        ORACAO_AREAS
                      ).map(area => (
                        <SelectItem key={area.value} value={area.value}>
                          {area.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label className="text-indigo-900 dark:text-indigo-100">Descreva seu pedido de oração *</Label>
                  <Textarea
                    value={pedidoOracao}
                    onChange={(e) => setPedidoOracao(e.target.value)}
                    placeholder="Compartilhe seu pedido de oração..."
                    rows={4}
                    className="bg-white dark:bg-card"
                  />
                  <p className="text-xs text-indigo-700 dark:text-indigo-300 mt-1">
                    Seu pedido será enviado ao líder responsável para que orem por você
                  </p>
                </div>
              </div>
            )}
            
            {/* Campos específicos para Evento em Dupla */}
            {project.tipo === "evento_dupla" && (
              <div className="space-y-4 p-4 rounded-lg bg-pink-50 dark:bg-pink-950/30 border border-pink-200 dark:border-pink-800">
                <h4 className="font-semibold text-pink-900 dark:text-pink-100 flex items-center gap-2">
                  <Users2 className="h-5 w-5" />
                  Informações do Convidado
                </h4>
                
                <p className="text-sm text-pink-700 dark:text-pink-300">
                  Este evento é para participação em dupla. Informe os dados do seu convidado(a).
                </p>
                
                <div className="flex gap-2 mb-4">
                  <Button
                    type="button"
                    variant={convidadoTipo === "avulso" ? "default" : "outline"}
                    className={convidadoTipo === "avulso" ? "bg-pink-600 hover:bg-pink-700" : ""}
                    onClick={() => setConvidadoTipo("avulso")}
                  >
                    <UserPlus className="h-4 w-4 mr-2" />
                    Convidado Novo
                  </Button>
                  <Button
                    type="button"
                    variant={convidadoTipo === "cadastrado" ? "default" : "outline"}
                    className={convidadoTipo === "cadastrado" ? "bg-pink-600 hover:bg-pink-700" : ""}
                    onClick={() => setConvidadoTipo("cadastrado")}
                  >
                    <Search className="h-4 w-4 mr-2" />
                    Buscar Cadastrado
                  </Button>
                </div>
                
                {convidadoTipo === "avulso" ? (
                  <div className="space-y-3">
                    <div>
                      <Label className="text-pink-900 dark:text-pink-100">Nome do Convidado *</Label>
                      <Input
                        value={convidadoNome}
                        onChange={(e) => setConvidadoNome(e.target.value)}
                        placeholder="Nome completo do convidado"
                        className="bg-white dark:bg-card"
                      />
                    </div>
                    <div>
                      <Label className="text-pink-900 dark:text-pink-100">Telefone (opcional)</Label>
                      <Input
                        value={convidadoTelefone}
                        onChange={(e) => setConvidadoTelefone(e.target.value)}
                        placeholder="(00) 00000-0000"
                        className="bg-white dark:bg-card"
                      />
                    </div>
                    <div>
                      <Label className="text-pink-900 dark:text-pink-100">E-mail (opcional)</Label>
                      <Input
                        type="email"
                        value={convidadoEmail}
                        onChange={(e) => setConvidadoEmail(e.target.value)}
                        placeholder="email@exemplo.com"
                        className="bg-white dark:bg-card"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div className="relative">
                      <Label className="text-pink-900 dark:text-pink-100">Buscar pessoa cadastrada</Label>
                      <Input
                        value={buscaConvidado}
                        onChange={(e) => setBuscaConvidado(e.target.value)}
                        placeholder="Digite o nome ou telefone para buscar..."
                        className="bg-white dark:bg-card"
                      />
                      
                      {/* Autocomplete dropdown - aparece quando digita */}
                      {buscaConvidado.length >= 2 && !convidadoPessoaId && (
                        <div className="absolute z-50 w-full mt-1 bg-white dark:bg-card border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                          {filteredPeople.length > 0 ? (
                            filteredPeople.slice(0, 10).map(pessoa => (
                              <button
                                key={pessoa.id}
                                type="button"
                                onClick={() => {
                                  setConvidadoPessoaId(pessoa.id);
                                  setConvidadoNome(pessoa.nome_completo || "");
                                  setConvidadoTelefone(pessoa.telefone || "");
                                  setConvidadoEmail(pessoa.email || "");
                                  setBuscaConvidado("");
                                }}
                                className="w-full p-3 text-left hover:bg-pink-50 dark:hover:bg-pink-950/50 transition-colors border-b last:border-0 flex items-center gap-3"
                              >
                                <div className="h-8 w-8 rounded-full bg-pink-100 dark:bg-pink-900 flex items-center justify-center flex-shrink-0">
                                  <User className="h-4 w-4 text-pink-600" />
                                </div>
                                <div className="min-w-0">
                                  <p className="font-medium truncate">{pessoa.nome_completo}</p>
                                  {pessoa.telefone && (
                                    <p className="text-xs text-muted-foreground">{pessoa.telefone}</p>
                                  )}
                                </div>
                              </button>
                            ))
                          ) : (
                            <div className="p-4 text-center text-muted-foreground">
                              <p>Nenhuma pessoa encontrada</p>
                              <p className="text-xs mt-1">Verifique o nome ou telefone digitado</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    
                    {/* Pessoa selecionada */}
                    {convidadoPessoaId && (
                      <div className="p-3 bg-pink-100 dark:bg-pink-900/50 rounded-lg flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <User className="h-4 w-4 text-pink-700" />
                          <div>
                            <span className="font-medium block">
                              {people.find(p => p.id === convidadoPessoaId)?.nome_completo || convidadoNome || "Pessoa selecionada"}
                            </span>
                            {convidadoTelefone && (
                              <span className="text-xs text-pink-600">{convidadoTelefone}</span>
                            )}
                          </div>
                        </div>
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          onClick={() => {
                            setConvidadoPessoaId("");
                            setConvidadoNome("");
                            setConvidadoTelefone("");
                            setConvidadoEmail("");
                          }}
                        >
                          Remover
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            
            {/* Payment fields - only for paid events */}
            {!project.gratuito && project.valor_inscricao > 0 && (
              <div className="space-y-4 p-4 rounded-lg bg-green-50 dark:bg-green-950/30 border border-green-200 dark:border-green-800">
                <h4 className="font-semibold text-green-900 dark:text-green-100 flex items-center gap-2">
                  <CreditCard className="h-5 w-5" />
                  Informações de Pagamento
                </h4>
                
                <div className="p-3 bg-green-100 dark:bg-green-900/50 rounded-lg">
                  <p className="text-sm text-green-800 dark:text-green-200">
                    Valor a pagar: <strong className="text-lg">R$ {project.valor_inscricao.toFixed(2).replace('.', ',')}</strong>
                  </p>
                </div>

                {/* PIX Info - if available */}
                {project.pix_chave && (
                  <div className="p-4 bg-white dark:bg-card rounded-lg border-2 border-dashed border-green-300 dark:border-green-700">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-green-800 dark:text-green-200">Chave PIX para pagamento:</span>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-8 px-2 text-green-700 hover:text-green-900"
                        onClick={() => {
                          navigator.clipboard.writeText(project.pix_chave);
                          toast.success("Chave PIX copiada!");
                        }}
                      >
                        <Copy className="h-4 w-4 mr-1" />
                        Copiar
                      </Button>
                    </div>
                    <div className="p-3 bg-green-50 dark:bg-green-950/50 rounded-lg font-mono text-sm break-all">
                      {project.pix_chave}
                    </div>
                    {project.pix_titular && (
                      <p className="text-xs text-muted-foreground mt-2">
                        Titular: <strong>{project.pix_titular}</strong>
                      </p>
                    )}
                  </div>
                )}
                
                <div>
                  <Label className="text-green-900 dark:text-green-100">Forma de Pagamento *</Label>
                  <Select value={formaPagamento} onValueChange={setFormaPagamento}>
                    <SelectTrigger className="bg-white dark:bg-card">
                      <SelectValue placeholder="Selecione a forma de pagamento" />
                    </SelectTrigger>
                    <SelectContent position="popper">
                      {FORMAS_PAGAMENTO.map(forma => (
                        <SelectItem key={forma.value} value={forma.value}>
                          {forma.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label className="text-green-900 dark:text-green-100">Data do Pagamento (opcional)</Label>
                  <Input
                    type="date"
                    value={dataPagamento}
                    onChange={(e) => setDataPagamento(e.target.value)}
                    className="bg-white dark:bg-card"
                  />
                  <p className="text-xs text-green-700 dark:text-green-300 mt-1">
                    Informe a data em que realizou ou realizará o pagamento
                  </p>
                </div>
              </div>
            )}
            
            {isInfantil && CriancasFields()}

            {/* Submit Button */}
            <Button 
              className={`w-full gap-2 ${project.tipo === "oracao" ? "bg-indigo-600 hover:bg-indigo-700" : project.tipo === "evento_dupla" ? "bg-pink-600 hover:bg-pink-700" : ""}`}
              onClick={handleEnroll}
              disabled={enrolling || (!pessoaAtual && !selectedPessoaId && !podeSelecionarPessoa)}
            >
              {enrolling ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : project.tipo === "oracao" ? (
                <HandHeart className="h-4 w-4" />
              ) : project.tipo === "evento_dupla" ? (
                <Users2 className="h-4 w-4" />
              ) : (
                <CheckCircle className="h-4 w-4" />
              )}
              {enrolling 
                ? (project.tipo === "oracao" ? "Enviando..." : "Inscrevendo...") 
                : project.tipo === "oracao" 
                  ? "Enviar Pedido de Oração" 
                  : project.tipo === "evento_dupla"
                    ? "Confirmar Inscrição em Dupla"
                    : "Confirmar Inscrição"
              }
            </Button>
            
            {/* Upload de comprovante - aparece após inscrição em evento pago */}
            {jaInscrito && !project.gratuito && project.valor_inscricao > 0 && (
              <div className="mt-6 p-4 rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800">
                <h4 className="font-semibold text-blue-900 dark:text-blue-100 flex items-center gap-2 mb-3">
                  <Upload className="h-5 w-5" />
                  Enviar Comprovante de Pagamento
                </h4>
                
                {inscricaoData?.numero_inscricao && (
                  <p className="text-sm text-blue-700 dark:text-blue-300 mb-3">
                    Número da inscrição: <strong>{inscricaoData.numero_inscricao}</strong>
                  </p>
                )}
                
                <p className="text-sm text-blue-700 dark:text-blue-300 mb-4">
                  Envie o comprovante de pagamento para agilizar a confirmação da sua inscrição.
                </p>
                
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleUploadComprovante}
                  accept="image/*,application/pdf"
                  className="hidden"
                />
                
                <Button
                  onClick={() => fileInputRef.current?.click()}
                  disabled={uploadingComprovante}
                  className="w-full bg-blue-600 hover:bg-blue-700"
                >
                  {uploadingComprovante ? (
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  ) : (
                    <Image className="h-4 w-4 mr-2" />
                  )}
                  {uploadingComprovante ? "Enviando..." : "Selecionar Comprovante"}
                </Button>
                
                <p className="text-xs text-muted-foreground mt-2 text-center">
                  Formatos aceitos: JPG, PNG, GIF ou PDF (máx. 5MB)
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      )}
      
      {/* Dialog de busca de convidado */}
      <Dialog open={dialogBuscaConvidado} onOpenChange={setDialogBuscaConvidado}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Buscar Convidado</DialogTitle>
            <DialogDescription>
              Selecione uma pessoa cadastrada para ser seu convidado
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <Input
              value={buscaConvidado}
              onChange={(e) => setBuscaConvidado(e.target.value)}
              placeholder="Buscar por nome ou telefone..."
              className="w-full"
            />
            
            <ScrollArea className="h-[300px]">
              <div className="space-y-2">
                {filteredPeople.slice(0, 20).map(pessoa => (
                  <button
                    key={pessoa.id}
                    onClick={() => {
                      setConvidadoPessoaId(pessoa.id);
                      setConvidadoNome(pessoa.nome_completo || "");
                      setDialogBuscaConvidado(false);
                    }}
                    className="w-full p-3 text-left rounded-lg hover:bg-muted transition-colors border"
                  >
                    <div className="flex items-center gap-3">
                      <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                        <User className="h-5 w-5 text-primary" />
                      </div>
                      <div>
                        <p className="font-medium">{pessoa.nome_completo}</p>
                        {pessoa.telefone && (
                          <p className="text-sm text-muted-foreground">{pessoa.telefone}</p>
                        )}
                      </div>
                    </div>
                  </button>
                ))}
                
                {filteredPeople.length === 0 && buscaConvidado && (
                  <p className="text-center text-muted-foreground py-8">
                    Nenhuma pessoa encontrada
                  </p>
                )}
              </div>
            </ScrollArea>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setDialogBuscaConvidado(false)}>
              Cancelar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
